import type { DeploymentOutcome } from '../../api';
import type { SummaryTone } from '../operation/OperationSummary';
import type { ImpactAssessment } from '../operation/impact';

/**
 * The one conclusion a deployment screen states (UX_ARCHITECTURE.md, rule
 * A): how the attempt ended, in a few words. What it did to production is a
 * separate fact, shown beside it as the impact label and as fields; the two
 * are never joined in one sentence.
 */
export function deploymentConclusion(outcome: DeploymentOutcome, impact: ImpactAssessment, failedFirst = false): { title: string; tone: SummaryTone } {
  switch (outcome) {
    case 'rehearsal':
      return { title: 'Rehearsal', tone: 'neutral' };
    case 'succeeded':
      return { title: 'Deployment succeeded', tone: impact.level === 'detected' ? 'danger' : impact.level === 'none_observed' ? 'success' : 'warning' };
    case 'succeeded_with_failures':
      return { title: 'Deployment partially succeeded', tone: 'warning' };
    case 'failed':
      return { title: 'Deployment failed', tone: 'danger' };
    case 'rolled_back':
      // A rollback the platform made after a failure is a failure that was contained;
      // one a person asked for is told by its own panel.
      return failedFirst ? { title: 'Deployment failed and was rolled back', tone: 'danger' } : { title: 'Deployment rolled back', tone: 'warning' };
    case 'cancelled':
      return { title: 'Deployment cancelled', tone: 'neutral' };
    case 'queued':
      return { title: 'Deployment queued', tone: 'neutral' };
    case 'deploying':
      return { title: 'Deployment running', tone: 'progress' };
  }
}
